export const transformObjectToFormData = (obj: Record<string, any>): FormData => {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, value]) => {
        if (value instanceof File) {
            formData.append(key, value);
            return;
        }
        if (value === null) {
            formData.append(key, '');
            return;
        }
        if (value === undefined) {
            return;
        }
        if (typeof value === 'object') {
            formData.append(key, JSON.stringify(value));
            return;
        }
        formData.append(key, value.toString());
    });
    return formData;
};
